import * as types from "../actions/ActionTypes";

/**Reducer used to handle the menu item list creation */
const MenuItemReducer = (state = {}, action) => {
  switch (action.type) {
    case types.setMenuItems:
      const mappedObj = mapCategoriesMenuItemData(
        action.data.categories,
        action.data.menuItems
      );
      return { ...mappedObj };
    case types.resetMenuItems:
      return {};
    default:
      return { ...state };
  }
};
export default MenuItemReducer;

/**Maps the categories and sub categories kinda into a tree */
function mapCategoriesMenuItemData(categoryData, menuItems) {
  const catObj = arrayToObject(categoryData);
  const object = {};
  const rawMenuItems = [];
  if (categoryData !== undefined && menuItems !== undefined) {
    /**
     * Loop through every item if they aren't an extra
     * check if the category is undefined then check if the catgory sub cateogry is undefined
     * if so create the object then push the menu items else just push the item
     */
    for (const menuItem of menuItems) {
      /**Item is an extra so we don't want in the list */
      if (menuItem.menu_item_sold_as_extra_only === false) {
        const categoryName = menuItem.menu_item_category_name;
        const subCatName = menuItem.menu_item_subcategory_name;
        const subCatId = menuItem.menu_item_subcategory_id;
        if (object[categoryName] === undefined) {
          object[categoryName] = {};
        }
        if (object[categoryName][subCatId] === undefined) {
          object[categoryName][subCatId] = {
            subcatName: subCatName,
            subcatPosition: catObj[subCatId].sort_position,
            menuItems: [],
            subcatDesc: catObj[subCatId].subcategory_desc,
          };
        }
        object[categoryName][subCatId].menuItems.push(menuItem);
        rawMenuItems.push(menuItem);
      }
    }
  }
  const sortedObject = {};
  let index1 = 0;
  /**Sorts the sub categories */
  Object.keys(object)
    .sort()
    .forEach((treeKeys) => {
      sortedObject[treeKeys] = { startIndex: index1, subCats: {} };
      const subCats = object[treeKeys];
      Object.keys(subCats)
        .sort((a, b) => {
          const aObj = subCats[a].subcatPosition;
          const bObj = subCats[b].subcatPosition;
          if (aObj < bObj) {
            return -1;
          }
          if (aObj > bObj) {
            return 1;
          }
          return 0;
        })
        .forEach((key) => {
          sortedObject[treeKeys] = {
            ...sortedObject[treeKeys],
            subCats: {
              ...sortedObject[treeKeys].subCats,
              [key]: { ...object[treeKeys][key], index: index1 },
            },
          };
          index1++;
        });
      sortedObject[treeKeys] = {
        ...sortedObject[treeKeys],
        endIndex: index1 - 1,
      };
    });
  return {
    tree: sortedObject,
    raw: rawMenuItems,
  };
}

const arrayToObject = (array) => {
  return array.reduce((item, newItem) => {
    return {
      ...item,
      [newItem.id]: newItem,
    };
  }, {});
};
